// extracted by mini-css-extract-plugin
export default {"fromTemplate":"FromTemplate_fromTemplate__qd+Y1","fromTemplateText":"FromTemplate_fromTemplateText__elQs2"};